import { render, staticRenderFns } from "./BeneficiariesList.vue?vue&type=template&id=7029be4d&"
import script from "./BeneficiariesList.vue?vue&type=script&lang=js&"
export * from "./BeneficiariesList.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiariesList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports